import { get, post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";

const API_PREFIX = "/print";

export const init = async () => {
  const response = await get(`${API_PREFIX}/`, authHeader());
  console.log("response", response);
  return response.data;
};

export const search = async request => {
  console.log("request", request);
  var requestUrl =
    "?serialNumber=" +
    request.serialNumber +
    "&grade=" +
    request.grade +
    "&classNumber=" +
    request.class +
    "&number=" +
    request.number +
    "&name=" +
    request.name +
    "&printTarget=" +
    request.printTarget;

  const response = await get(`${API_PREFIX}/search${requestUrl}`, authHeader());
  console.log("response", response);
  return response.data;
};

export const print = async request => {
  const response = await post(`${API_PREFIX}/`, request, authHeader());
  console.log("response", response);
  return response.data;
}

export const dataAnalysisPrint = async request => {
  const response = await post(`${API_PREFIX}/dataAnalysis`, request, authHeader());
  console.log("response", response);
  return response.data;
}
